export const SYSMON_EVENT_ID: string = "ID";
export const SYSMON_EVENT_SOURCE: string = "SOURCE";
export const SYSMON_EVENT_FQDN: string = "FQDN";
export const SYSMON_EVENT_TIMESTAMP: string = "TIMESTAMP";
export const SYSMON_EVENT_STATUS: string = "STATUS";
export const SYSMON_EVENT_STATUS_DISP_TXT: string = "STATUS_DISP_TXT";
export const SYSMON_EVENT_FQDN_DISP_TXT: string = "FQDN_DISP_TXT";
export const SYSMON_EVENT_GROUP_FQDN_DISP_CNT: string = "GROUP_FQDN_DISP_CNT";
export const SYSMON_EVENT_GROUP_FQDN_DISP_TXT: string = "GROUP_FQDN_DISP_TXT";

export const SYSMON_EVENT_FQDN_HUB_PREFIX: string = "STATUS.CONNECTION.HUB.";
export const CONNECTION_UP: string = "UP";
export const CONNECTION_DOWN: string = "DOWN";
export const CONNECTION_OUT_OF_SERVICE: string = "OUT_OF_SERVICE";
export const CONNECTION_UNKNOWN: string = "UNKNOWN";
export const CONNECTION_UNMAPPED: string = "UNMAPPED";
